// extracted by mini-css-extract-plugin
export var content = "A+p0G";
export var ctaButton = "pWMgE";
export var ctas = "_33FUy";
export var image = "P+WSb";
export var paragraph = "_6r-Je";
export var title = "MBTTE";